export default __webpack_public_path__ + "static/media/doctor_avatar@2x.1786c01d.png";